export default __webpack_public_path__ + "static/media/img_background_login2.0a207d27.jpg";